import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import { LoginRequest } from './request/login-request';
//import { environment };
//import { IOauthResponse } from '../response/i-oauth.request';
import { StrictHttpResponse as __StrictHttpResponse} from '../generic/strict-http.response';
import { SecurityProvider } from '../../../providers/security.provider';
import { LoginResponse } from './response/login-response';
import { ApiService } from '../../../helpers/api.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends ApiService{
  constructor(http: HttpClient) { 
    super(http);
  }

  postLoginResponse(parameters: LoginRequest, headers?: { [key: string]: string }):Observable<__StrictHttpResponse<LoginResponse>> {
    return ApiService.requestApi<LoginRequest, LoginResponse>(
      this.http, {
        method: 'POST',
        parameters: parameters,
        headers: headers,
        url: '/manager/main/svc/login'
      }
    );
  }

  
  addHeaders(req: HttpRequest<any>, headers?: { [key: string]: string } | null): HttpRequest<any> {
    let h = <any>{};
    for(var name in req.headers.keys) {
      h[name] = req.headers.get(name);
    }
    if (headers) {
      for (const key of Object.keys(headers)) {
        h[key] =  headers[key];
      }
    }
    h['X-TRACK-HEADER'] = SecurityProvider.hash(JSON.stringify(req.body));
    
    return req.clone({setHeaders: h});
  }

  
  isAuthorized(): Observable<any> {
    return of(true);
  }
}
